enum ProvisionType {
  WorkCapital = 'WorkCapital',
  SpareCapital = 'SpareCapital',
  FixedWorkCapital = 'FixedWorkCapital',
}

export default ProvisionType;
